import React, { Component } from "react";
import emptycart from "../../assets/img/empty-shoppingcart.png";
import { CartContext } from "../../components/ParadigmaCartProvider/ParadigmaCartProvider";
import format from "../../functions/functions.js";
import CantidadSelector from "../../components/CantidadSelector/CantidadSelector";
import FreeShipping from "../../components/ShippingComponent/Shipping.js";
import logo from "../../assets/img/brand/LogoWeb.png";
import LoadingScreen from "react-loading-screen";
import Swal from "sweetalert2";
import apifunctions from "../../api/functions";
import api from "../../api/api";
import "./styles.scss";

class CartMenu extends Component {
    static contextType = CartContext;

    state = {
        cartItems: [],
        porcentajeIVA: 0,
        porcentajeIIBB: 0,
        montoIVA: 0,
        montoIIBB: 0,
        subtotal: 0,
        loaded: false,
        total: 0,
        previousContextSelectedItems: null,
        hasFreeShipping: false,
        remainingAmount: 0,
        idFormaPago: 0,
        FormaPago: "",
        idTransporte: 0,
        TransporteAsociado: "",
        buyerDetails: null,
    };

    componentDidMount() {
        this.updateCartData(this.context.selectedItems, 0, this.state.loaded);
        apifunctions.post(
            api.api.auth.profile,
            null,
            null,
            (response) => {
                const normalizeKeys = (obj) =>
                    Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key.charAt(0).toLowerCase() + key.slice(1),
                            value && typeof value === "object"
                                ? normalizeKeys(value)
                                : value,
                        ])
                    );
                this.setState({ buyerDetails: normalizeKeys(response.data) });
            },
            (error) => {
                console.error(
                    "Error al obtener los datos del comprador:",
                    error
                );
            }
        );
        // Obtener los transportes asociados
        apifunctions.get(
            api.api.transportesAsociados,
            null,
            null,
            null,
            (response) => {
                const transportes = response.data.transportesAsociados;
                const transportePredeterminado = transportes.find(
                    (t) => t.checked == true
                );
                this.setState({
                    idTransporte: transportePredeterminado
                        ? transportePredeterminado.id
                        : null,
                    TransporteAsociado: transportePredeterminado.transporte
                });
            }
        );

        // Obtener las formas de pago
        apifunctions.get(api.api.formasdepago, null, null, null, (response) => {
            const formasPago = response.data.formasdepago;
            const formaPagoPredeterminada = formasPago.find(
                (fp) => fp.checked == true
            );
            this.setState({
                idFormaPago: formaPagoPredeterminada
                    ? formaPagoPredeterminada.id
                    : null,
                FormaPago: formaPagoPredeterminada.formapago
            });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.previousContextSelectedItems !==
            this.context.selectedItems
        ) {
            this.updateCartData(
                this.context.selectedItems,
                0,
                this.state.loaded
            );
            this.setState({
                previousContextSelectedItems: this.context.selectedItems,
            });
        }
    }

    handleFreeShippingChange = (hasFreeShipping) => {
        this.setState({ hasFreeShipping });
    };

    handleRemainingAmount = (remainingAmount) => {
        this.setState({ remainingAmount });
    };

    updateCartData = (carrito, idformapago, loaded) => {
        this.setState({ loaded: false });
        let params = {
            cart: carrito.map((item) => ({
                code: item.code,
                quantity: item.quantity,
                checked: true,
                quantityBahiaBlanca: item.quantityBahiaBlanca || 0,
                quantityBuenosAires: item.quantityBuenosAires || 0,
                quantityCordoba: item.quantityCordoba || 0,
            })),
            FormaPago: idformapago,
        };
        params = btoa(JSON.stringify(params));
        apifunctions
            .post(
                api.api.generatecart,
                null,
                { hash: params },
                (response) => {
                    this.setState((prevState) => {
                        let compare = (a, b) => {
                            return a.code > b.code
                                ? 1
                                : a.code < b.code
                                ? -1
                                : 0;
                        };
                        prevState.loaded = loaded;
                        prevState.cartItems = response.data.productos || [];
                        prevState.cartItems.sort(compare);
                        prevState.porcentajeIVA =response.data.PorcentajeIVA || 0;
                        prevState.porcentajeIIBB =response.data.PorcentajeIIBB || 0;
                        prevState.montoIVA = response.data.MontoIVA || 0;
                        prevState.montoIIBB = response.data.MontoIIBB || 0;
                        prevState.subtotal = response.data.SubTotal || 0;
                        prevState.total = response.data.Total || 0;
                        idformapago = response.idformapago;
                        return prevState;
                    });
                },
                () => {
                    this.lock = false;
                },
                () => {
                    this.lock = false;
                }
            )
            .finally(() => {
                this.setState({ loaded: true });
            });
    };

    crearComoPedido = () => {
        const {
            cartItems,
            idFormaPago,
            idTransporte,
            buyerDetails,
            hasFreeShipping,
        } = this.state;

        if (!idFormaPago || !idTransporte || cartItems.length === 0) {
            Swal.fire({
                icon: "error",
                title: "Datos incompletos",
                text: "Faltan datos para confirmar el pedido.",
            });
            return;
        }

        const totalQuantity = cartItems.reduce(
            (acc, item) =>
                acc +
                (item.quantityBahiaBlanca || 0) +
                (item.quantityBuenosAires || 0) +
                (item.quantityCordoba || 0),
            0
        );

        if (totalQuantity === 0) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "No puedes realizar un pedido con cantidad total de 0.",
            });
            return;
        }

        const CodEnvio =
            hasFreeShipping && (idTransporte === 2 || idTransporte === "2");

        const footerMessage = hasFreeShipping
            ? "<small>Recuerde configurar el transporte asociado para el envío gratis.</small>"
            : "<small>Sume productos para conseguir envío gratis.</small>";

        Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Estás seguro que deseas confirmar el pedido?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, confirmar",
            cancelButtonText: "Cancelar",
            footer: footerMessage,
        }).then((result) => {
            if (result.isConfirmed) {
                const params = {
                    observaciones: "",
                    items: cartItems
                        .filter((item) => item.checked)
                        .map((item) => ({
                            code: item.code,
                            quantity: item.quantity,
                            quantityBahiaBlanca: item.quantityBahiaBlanca || 0,
                            quantityBuenosAires: item.quantityBuenosAires || 0,
                            quantityCordoba: item.quantityCordoba || 0,
                        })),
                    idTransporte,
                    idFormaPago,
                    buyer: {
                        ...buyerDetails,
                        email:
                            localStorage.getItem("displayname") ||
                            buyerDetails.email,
                    },
                    CodEnvio,
                };

                const hash = btoa(JSON.stringify(params));

                apifunctions.post(
                    api.api.pedidosGenerar,
                    null,
                    { hash },
                    (response) => {
                        // Limpieza del carrito
                        this.context.removeAllItems(() => {
                            // Vaciar el carrito
                            this.setState({ cartItems: [] });
                            // Mostrar el mensaje de éxito
                            Swal.fire({
                                icon: "success",
                                title: "¡El pedido fue creado con éxito!",
                                showConfirmButton: false,
                                timer: 1500,
                            });
                        });
                        (error) => {
                            console.error(
                                "Error al confirmar el pedido:",
                                error
                            );
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: "No se pudo confirmar el pedido. Intente nuevamente.",
                            });
                        };
                    }
                );
            }
        });
    };

    render() {
        const {
            cartItems,
            loaded,
            total,
            montoIVA,
            montoIIBB,
            subtotal,
            hasFreeShipping,
            buyerDetails,
            idFormaPago,
            FormaPago,
            idTransporte,
            TransporteAsociado
        } = this.state;

        let IdGrupo = localStorage.getItem("Grupo_id");
        console.log("Subtotal\n",subtotal);
        console.log("Iva monton\n",montoIVA);
        console.log("Monto IIBB\n",montoIIBB);
        console.log("Monto TOTAL FINAL\n",total);


        return (
            <div className="cartHover_menu">
                <LoadingScreen
                    loading={!loaded}
                    spinnerColor="#9ee5f8"
                    logoSrc={logo}
                >
                    <div className="cartHover_display">
                        {cartItems.length > 0 ? (
                            cartItems.map((item) => (
                                <div key={item.code} className="cartHover_item">
                                 <button
                                        className="btn btn-danger rounded-pill mb-2 pull-right"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.context.removeItem(item.code);
                                        }}
                                    >
                                        X
                                    </button>
                                    <div className="cartHover_item_header">
                                        <img
                                            src={api.BASE_URL + item.images[0]}
                                            className="cartHover_item_image"
                                            alt={item.Titulo}
                                        />
                                          {item.checked && (
                                        <ul className="cartHover_stock_list">
                                            <p className="cartHover_item_codigo">{item.Codigo}</p>
                                            {item.stock_bsas > 0 &&
                                                IdGrupo !== "20" && (
                                                    <li className="cartHover_stock_item">
                                                        <CantidadSelector
                                                            className="cartHover_cantidad_selector"
                                                            cantidadDisponible={
                                                                999
                                                            }
                                                            cantidad={
                                                                item.quantityBuenosAires
                                                            }
                                                            onChange={(
                                                                quantity
                                                            ) =>
                                                                this.context.setItem(
                                                                    item.code,
                                                                    quantity,
                                                                    "buenos_aires"
                                                                )
                                                            }
                                                        />
                                                    </li>
                                                )}
                                            <li className="cartHover_stock_item">
                                                <CantidadSelector
                                                    className="cartHover_cantidad_selector"
                                                    cantidadDisponible={999}
                                                    cantidad={
                                                        item.quantityBahiaBlanca
                                                    }
                                                    onChange={(quantity) =>
                                                        this.context.setItem(
                                                            item.code,
                                                            quantity,
                                                            "bahia_blanca"
                                                        )
                                                    }
                                                />
                                            </li>
                                            {/*Deposito CORDOBA*/}
                                            {item.stock_cordoba > 0 &&
                                                IdGrupo === "20" && (
                                                    <li className="cartHover_stock_item">
                                                        <CantidadSelector
                                                            className="cartHover_cantidad_selector"
                                                            cantidadDisponible={
                                                                999
                                                            }
                                                            cantidad={
                                                                item.quantityCordoba
                                                            }
                                                            onChange={(
                                                                quantity
                                                            ) => {
                                                                this.context.setItem(
                                                                    item.code,
                                                                    quantity,
                                                                    "cordoba"
                                                                );
                                                            }}
                                                        />
                                                    </li>
                                                )}
                                        </ul>
                                    )}
                                        <p className="cartHover_item_title">
                                            {item.Titulo}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="cartHover_empty">
                                <h1>Carrito vacío</h1>
                                <img
                                    width={100}
                                    height={100}
                                    src={emptycart}
                                    alt={"Carrito vacio"}
                                />
                            </div>
                        )}
                        {cartItems.length > 0 && (
                            <div>
                                <FreeShipping
                                    totalPrice={format.FormatPrice(total)}
                                    onRemainingAmount={
                                        this.handleRemainingAmount
                                    }
                                    onFreeShippingChange={
                                        this.handleFreeShippingChange
                                    }
                                    type={"cart-menu"}
                                />
                                <div className="container">
                                    <div className="row justify-content-end text-right mb-2">
                                        <div className="col-12 col-md-8">
                                            <div className="subtotal mb-2 cartHover_total">
                                                Subtotal: $
                                                {format.FormatPrice(subtotal)}
                                            </div>
                                            <div className="iva mb-2 cartHover_total">
                                                IVA 21%: $
                                                {format.FormatPrice(montoIVA)}
                                            </div>
                                            {/* <div className="iibb mb-2 cartHover_total">
                                                IIBB: $
                                                {format.FormatPrice(montoIIBB)}
                                            </div> */}
                                            <h2 className="text-muted ">
                                                Total: $
                                                {format.FormatPrice(total)}
                                            </h2>
                                        </div>
                                    </div>
                                </div>

                                <div className="container">
                                    <div className=" container-asociados row justify-content-end text-right mb-2">
                                        <p>Transporte Asociado: <strong>{TransporteAsociado}</strong></p>
                                        <p>Forma de Pago: <strong>{FormaPago}</strong></p>
                                       </div>
                                </div>

                                {cartItems.length > 0 && (
                                    <div className="text-center mt-3 mb-4" >
                                        <button
                                            className="btn btn-success rounded-pill btn-confirmar"
                                            onClick={this.crearComoPedido}
                                        >
                                            Confirmar Pedido
                                        </button>
                                    </div>
                                )}

                                <button
                                    className="cartHover_button btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        Swal.fire({
                                            title: "¿Vaciar el carrito?",
                                            text: "¿Está seguro de que desea vaciar el carrito?",
                                            icon: "warning",
                                            showCancelButton: "true",
                                            cancelButtonText: "Cancelar",
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText:
                                                "Sí, vaciar el carrito!",
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.context.removeAllItems(
                                                    () => {
                                                        this.setState({
                                                            loaded: false,
                                                        });
                                                    }
                                                );
                                                Swal.fire({
                                                    title: "¡El carrito ha sido vaciado!",
                                                    icon: "success",
                                                    showConfirmButton: false,
                                                    timer: 1200,
                                                });
                                            }
                                        });
                                    }}
                                >
                                    {" "}
                                    Vaciar Carrito{" "}
                                </button>
                            </div>
                        )}
                    </div>
                </LoadingScreen>
            </div>
        );
    }
}

export default CartMenu;



// WEBPACK FOOTER //
// ./src/views/Cart/CartMenu.js